import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Form, Formik } from 'formik';
import styled from 'styled-components';
import * as Yup from 'yup';
import { HTTPMethod } from 'http-method-enum';
import { Box } from '@yoweb/ui/components/Box';
import { Spacer } from '@yoweb/ui/components/Spacer';
import { Text, Title } from '@yoweb/ui/components/typography';
import { Trans, useTranslation } from '@yoweb/next-i18next';
import { Button, ButtonLink } from '@yoweb/ui/components/buttons';
import { Textarea, useError, ErrorDisplay } from '@yoweb/ui/components/form';
import { Modal } from '@yoweb/ui/components/Modal';
import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { API_FEEDBACK } from '@poplar/constants/routes';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { MODAL_STANDARD_MAX_WIDTH } from '@poplar/constants/modals';
import { createSupportEmails } from '@yoweb/utils/contact';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { useUser } from '@poplar/hooks/useUser';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PageTranslations = ['account'];
export var Feedback = function Feedback(_ref) {
  var _profile$personName, _profile$personName2, _profile$emailAddress;

  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useToast = useToast(),
      showToastMessage = _useToast.showToastMessage;

  var validationSchema = Yup.object({
    feedback: Yup.string().trim().required(t('validation.required'))
  });
  var errorDisplay = useError();

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';
  var supportEmails = createSupportEmails(lcLocale);

  var _useUser = useUser(),
      profile = _useUser.profile;

  var emailBody = t('feedback.email-body', {
    name: profile === null || profile === void 0 ? void 0 : (_profile$personName = profile.personName) === null || _profile$personName === void 0 ? void 0 : _profile$personName.givenName,
    lastName: profile === null || profile === void 0 ? void 0 : (_profile$personName2 = profile.personName) === null || _profile$personName2 === void 0 ? void 0 : _profile$personName2.familyName,
    email: profile === null || profile === void 0 ? void 0 : (_profile$emailAddress = profile.emailAddress) === null || _profile$emailAddress === void 0 ? void 0 : _profile$emailAddress.address
  });
  var encodedEmailBody = encodeURIComponent(emailBody);

  var submit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2, _ref3) {
      var feedback, resetForm;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              feedback = _ref2.feedback;
              resetForm = _ref3.resetForm;
              errorDisplay.clear();
              _context.next = 5;
              return fetchJson(API_FEEDBACK, {
                method: HTTPMethod.POST,
                body: JSON.stringify({
                  text: feedback
                })
              }).then(function () {
                setIsOpen(false);
                showToastMessage({
                  message: t('feedback.sent-success')
                });
                resetForm();
              })["catch"](function (ex) {
                errorDisplay.set();
                throw ex;
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submit(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(Formik, {
    initialValues: {
      feedback: ''
    },
    onSubmit: submit,
    validationSchema: validationSchema,
    children: function children(_ref5) {
      var isSubmitting = _ref5.isSubmitting,
          dirty = _ref5.dirty,
          isValid = _ref5.isValid,
          handleSubmit = _ref5.handleSubmit,
          resetForm = _ref5.resetForm;
      return /*#__PURE__*/_jsxs(Modal, {
        "data-testid": "feedback-modal",
        actionButtons: /*#__PURE__*/_jsxs(ActionButtons, {
          children: [/*#__PURE__*/_jsx(Button, {
            "data-testid": "submit-button",
            isDisabled: !dirty || !isValid,
            isLoading: isSubmitting,
            onClick: function onClick() {
              return handleSubmit();
            },
            type: "submit",
            variant: "primary",
            size: "md",
            children: t('feedback.submit')
          }, "btn-action-submit"), /*#__PURE__*/_jsx(Button, {
            variant: "secondary",
            "data-testid": "cancel-button",
            onClick: function onClick() {
              setIsOpen(false);
              resetForm();
            },
            size: "md",
            children: t('actions.cancel')
          }, "btn-action-cancel")]
        }),
        isOpen: isOpen,
        onClose: function onClose() {
          return setIsOpen(false);
        },
        hasCloseButton: true,
        maxWidth: MODAL_STANDARD_MAX_WIDTH,
        children: [/*#__PURE__*/_jsx(Title, {
          size: "md",
          children: t('feedback.title')
        }), /*#__PURE__*/_jsx(Box, {
          mt: "normal1",
          children: /*#__PURE__*/_jsx(Text, {
            children: t('feedback.description')
          })
        }), /*#__PURE__*/_jsx(Spacer, {
          size: "normal2"
        }), /*#__PURE__*/_jsxs(Form, {
          children: [(errorDisplay === null || errorDisplay === void 0 ? void 0 : errorDisplay.message) && /*#__PURE__*/_jsx(Box, {
            mb: "normal1",
            children: /*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
              withBorder: true
            }, errorDisplay), {}, {
              scrollTo: true
            }))
          }), /*#__PURE__*/_jsx(Textarea, {
            label: t('feedback.txtLabel'),
            name: "feedback",
            id: "feedback"
          }), isJapanLocale && /*#__PURE__*/_jsx(Text, {
            size: "md",
            variant: "muted",
            style: {
              marginTop: pxToRem(8)
            },
            children: /*#__PURE__*/_jsx(Trans, {
              t: t,
              i18nKey: "feedback.description2",
              components: [/*#__PURE__*/_jsx(ButtonLink, {
                size: "md",
                target: "_blank",
                href: "mailto:".concat(supportEmails.support, "?body=").concat(encodedEmailBody)
              }, 0)]
            })
          })]
        })]
      });
    }
  });
};
var ActionButtons = styled.div.withConfig({
  componentId: "sc-1qbgs9-0"
})(["display:flex;flex-direction:row-reverse;> :nth-child(1){margin-bottom:0;margin-left:", ";}"], getSpace('normal1'));